module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('notification'), _vm._v(" "), (_vm.loggedIn) ? _c('navigation-bar') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container",
    attrs: {
      "id": "content"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-48d68835!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1151
// module chunks = 2